/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';

const TransactionProcessed = ({ options }) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const { ledgerAccount, wallet } = options;

  const openTransactionHistory = () => {
    history.push(`/dashboard/accounts/${wallet?.coin}/details`, {
      ledgerAccount,
      wallet,
    });
  };

  const renderFooter = () => (
    <button
      type="button"
      className="btn rounded-4 bg-transparent p-3 border border-shadow text-center mt-4"
      tabIndex={-1}
      onClick={openTransactionHistory}
      onKeyDown={null}>
      {translate('transaction_processed_button_label')}
    </button>
  );

  return (
    <ModalBodyLayout renderFooter={renderFooter}>
      <div className="mx-auto">
        <div className="text-center mt-5">
          <img className="w-50 mb-2" src="./assets/images/transaction-success.svg" alt="Success" />
        </div>
        <div className="text-center mt-4">
          <p className="text-f5 text-dark">{translate('transaction_processed_title')}</p>
        </div>
        <div className="text-center mt-4">
          <p className="text-f5 text-shadow">{translate('transaction_processed_subtitle')}</p>
        </div>
        <div className="w-100 mt-4 p-0">
          <div className="alert alert-info d-flex align-items-center" role="alert">
            <div>
              <i className="icon icon-info-icon position-relative top-0" />
            </div>
            <span className="content">{translate('transaction_processed_note')}</span>
          </div>
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default TransactionProcessed;

TransactionProcessed.propTypes = {
  options: PropTypes.object,
};

TransactionProcessed.defaultProps = {
  options: null,
};
